import { render, staticRenderFns } from "./FileDropzone.vue?vue&type=template&id=9aa426ba&"
import script from "./FileDropzone.vue?vue&type=script&lang=ts&"
export * from "./FileDropzone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports